import React, { useEffect, useState } from "react";
import style from "../Style.module.scss";
import ButtonIcon from "../../../components/ButtonIcon/ButtonIcon";
import StatusDot from "../../../components/StatusDot/StatusDot";
import Calender from "../../../assets/svg/icons/common/Calender";
import CaretDown from "../../../assets/svg/icons/common/CaretDown";
import Download from "../../../assets/svg/icons/common/Download";
import TrendUp from "../../../assets/svg/icons/common/TrendUp";
import Tabs from "../../../components/Tabs/Tabs";
import Sales from "./Sales/Sales";
import Detail from "./Details/Details";
import Activity from "../../application/components/Activity/Activity";
import Pricing from "./Pricing/Pricing";
import Chargeback from "./Chargeback/Chargeback";
import useCommonStore from "../../../stores/common";
import useMerchantStore from "../../../stores/merchant";
import moment from "moment";
import {
  getPreappById,
  getMerchantInfo,
  getMerchantStatement,
  getMerchantDetails,
} from "../../../../api";
import Spinner from "../../../components/Loaders/Spinner";
import MonthPicker from "../../../components/MonthPicker/Index";
import toast from "react-hot-toast";

function Details() {
  const toggleShowDetails = useCommonStore((state) => state.toggleShowDetails);
  const toggleExpandDetails = useCommonStore(
    (state) => state.toggleExpandDetails,
  );
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);
  const setActiveApp = useMerchantStore((state) => state.setActiveApp);
  const [loading, setLoading] = useState(true);

  const tabs = [
    { label: "Sales", content: <Sales /> },
    { label: "Chargebacks", content: <Chargeback /> },
    { label: "Details", content: <Detail /> },
    {
      label: "Pricing",
      content: <Pricing />,
    },
    {
      label: "Activity",
      content: <Activity activeApp={activeApp} />,
      badge: "7",
    },
  ];

  const handleTabSelect = (index) => {
    console.log(`Selected Tab: ${index}`);
  };

  const onCloseClick = () => {
    toggleShowDetails();

    if (expandDetails) {
      toggleExpandDetails();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        console.log("Fetching data for activeApp:", activeApp);

        const preappResponse = await getPreappById({ id: activeApp.id });

        if (!preappResponse.status) {
          console.error("Failed to fetch preapp data");
          return;
        }

        const merchantResponse = await getMerchantInfo({ id: activeApp.id });

        if (!merchantResponse.status) {
          console.error("Failed to fetch merchant info");
          return;
        }

        const merchant_details = await getMerchantDetails({
          powerapp_id: activeApp.id,
        });
        if (!merchant_details.status) {
          console.error("Failed to fetch merchant getMerchantDetails");
          return;
        }

        setLoading(false);
        setActiveApp({
          ...preappResponse.data,
          bankinfo: merchantResponse.bankinfo,
          creditcardprocess: merchantResponse.creditcardprocess,
          powerappbusinessprofile: merchantResponse.powerappbusinessprofile,
          powerappequipment: merchantResponse.powerappequipment,
          prices: merchantResponse.prices,
          signers: merchantResponse.signers,
          billing: merchantResponse.billing,
          powerappReferral: merchantResponse.powerappReferral,
          merchant_details: merchant_details.data,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (activeApp?.id) {
      fetchData();
    }
  }, [activeApp?.id]);

  const getFullMonthName = (shortMonth) => {
    const date = new Date(`${shortMonth} 1, 2020`);
    const options = { month: "long" };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

  const handleDownload = (base64Pdf, file_name) => {
    const byteCharacters = Buffer.from(base64Pdf, "base64");
    const blob = new Blob([byteCharacters], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = file_name;
    link.click();

    window.URL.revokeObjectURL(url);
  };

  const downloadStatement = (data) => {
    const toastId = toast.loading(
      "Your statement is being run, do not close the page. The file will be downloaded automatically",
      { duration: 5 * 60 * 1000 },
    );
    getMerchantStatement({
      powerapp_id: activeApp.id,
      month: getFullMonthName(data.month),
      year: data.year,
    })
      .then((response) => {
        if (response.status) {
          handleDownload(
            response.data,
            `Merchant_Statement_${data.year}_${getFullMonthName(data.month)}.pdf`,
          );
          toast.success("Statement downloaded successfully", {
            id: toastId,
            duration: 30 * 1000,
          });
        } else {
          toast.error(response.message, { id: toastId, duration: 30 * 1000 });
        }
      })
      .catch((error) => {
        toast.error("Something went wrong!", {
          id: toastId,
          duration: 30 * 1000,
        });
      });
  };

  return (
    <div className={style.details_container}>
      {!loading && (
        <>
          <div className={style.details_head}>
            <button
              className={style.expand_button}
              onClick={() => {
                toggleExpandDetails();
              }}
            >
              {!expandDetails ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96452 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM14.0306 15.2194C14.1003 15.2891 14.1556 15.3718 14.1933 15.4628C14.231 15.5539 14.2504 15.6515 14.2504 15.75C14.2504 15.8485 14.231 15.9461 14.1933 16.0372C14.1556 16.1282 14.1003 16.2109 14.0306 16.2806C13.9609 16.3503 13.8782 16.4056 13.7872 16.4433C13.6961 16.481 13.5986 16.5004 13.5 16.5004C13.4015 16.5004 13.3039 16.481 13.2128 16.4433C13.1218 16.4056 13.0391 16.3503 12.9694 16.2806L9.21938 12.5306C9.14965 12.461 9.09433 12.3783 9.05658 12.2872C9.01884 12.1962 8.99941 12.0986 8.99941 12C8.99941 11.9014 9.01884 11.8038 9.05658 11.7128C9.09433 11.6217 9.14965 11.539 9.21938 11.4694L12.9694 7.71937C13.0391 7.64969 13.1218 7.59442 13.2128 7.5567C13.3039 7.51899 13.4015 7.49958 13.5 7.49958C13.5986 7.49958 13.6961 7.51899 13.7872 7.5567C13.8782 7.59442 13.9609 7.64969 14.0306 7.71937C14.1003 7.78906 14.1556 7.87178 14.1933 7.96283C14.231 8.05387 14.2504 8.15145 14.2504 8.25C14.2504 8.34855 14.231 8.44613 14.1933 8.53717C14.1556 8.62822 14.1003 8.71094 14.0306 8.78063L10.8103 12L14.0306 15.2194Z"
                    fill="#254FE2"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M12 2.25C10.0716 2.25 8.18657 2.82183 6.58319 3.89317C4.97982 4.96452 3.73013 6.48726 2.99218 8.26884C2.25422 10.0504 2.06114 12.0108 2.43735 13.9021C2.81355 15.7934 3.74215 17.5307 5.10571 18.8943C6.46928 20.2579 8.20656 21.1865 10.0979 21.5627C11.9892 21.9389 13.9496 21.7458 15.7312 21.0078C17.5127 20.2699 19.0355 19.0202 20.1068 17.4168C21.1782 15.8134 21.75 13.9284 21.75 12C21.7473 9.41498 20.7192 6.93661 18.8913 5.10872C17.0634 3.28084 14.585 2.25273 12 2.25ZM14.7806 12.5306L11.0306 16.2806C10.9609 16.3503 10.8782 16.4056 10.7872 16.4433C10.6961 16.481 10.5986 16.5004 10.5 16.5004C10.4015 16.5004 10.3039 16.481 10.2128 16.4433C10.1218 16.4056 10.0391 16.3503 9.96938 16.2806C9.8997 16.2109 9.84442 16.1282 9.80671 16.0372C9.769 15.9461 9.74959 15.8485 9.74959 15.75C9.74959 15.6515 9.769 15.5539 9.80671 15.4628C9.84442 15.3718 9.8997 15.2891 9.96938 15.2194L13.1897 12L9.96938 8.78063C9.82865 8.63989 9.74959 8.44902 9.74959 8.25C9.74959 8.05098 9.82865 7.86011 9.96938 7.71937C10.1101 7.57864 10.301 7.49958 10.5 7.49958C10.699 7.49958 10.8899 7.57864 11.0306 7.71937L14.7806 11.4694C14.8504 11.539 14.9057 11.6217 14.9434 11.7128C14.9812 11.8038 15.0006 11.9014 15.0006 12C15.0006 12.0986 14.9812 12.1962 14.9434 12.2872C14.9057 12.3783 14.8504 12.461 14.7806 12.5306Z"
                    fill="#254FE2"
                  />
                </svg>
              )}

              <span>{!expandDetails ? "Expand Details" : "Minimize"}</span>
            </button>

            <ButtonIcon onClick={onCloseClick}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M19.2806 18.2194C19.3503 18.289 19.4056 18.3718 19.4433 18.4628C19.481 18.5539 19.5004 18.6514 19.5004 18.75C19.5004 18.8485 19.481 18.9461 19.4433 19.0372C19.4056 19.1282 19.3503 19.2109 19.2806 19.2806C19.2109 19.3503 19.1282 19.4056 19.0372 19.4433C18.9461 19.481 18.8485 19.5004 18.75 19.5004C18.6515 19.5004 18.5539 19.481 18.4628 19.4433C18.3718 19.4056 18.2891 19.3503 18.2194 19.2806L12 13.0603L5.78062 19.2806C5.63989 19.4213 5.44902 19.5004 5.25 19.5004C5.05097 19.5004 4.8601 19.4213 4.71937 19.2806C4.57864 19.1399 4.49958 18.949 4.49958 18.75C4.49958 18.551 4.57864 18.3601 4.71937 18.2194L10.9397 12L4.71937 5.78061C4.57864 5.63988 4.49958 5.44901 4.49958 5.24999C4.49958 5.05097 4.57864 4.8601 4.71937 4.71936C4.8601 4.57863 5.05097 4.49957 5.25 4.49957C5.44902 4.49957 5.63989 4.57863 5.78062 4.71936L12 10.9397L18.2194 4.71936C18.3601 4.57863 18.551 4.49957 18.75 4.49957C18.949 4.49957 19.1399 4.57863 19.2806 4.71936C19.4214 4.8601 19.5004 5.05097 19.5004 5.24999C19.5004 5.44901 19.4214 5.63988 19.2806 5.78061L13.0603 12L19.2806 18.2194Z"
                  fill="#A4A3A8"
                />
              </svg>
            </ButtonIcon>
          </div>

          <div className={style.application_min_data}>
            <div className={style.container_min_data}>
              <div className={style.left}>
                <p className={style.heading}>{activeApp?.field_dba}</p>
                <div className={style.status_desc}>
                  <StatusDot color="#37B450" />
                  <span>
                    Open since{" "}
                    {moment(activeApp?.power_app_submission?.created_at).format(
                      "D/MM/YYYY",
                    )}
                  </span>
                </div>
              </div>

              <div className={style.right}>
                <ButtonIcon bgColor="#EDEDF4" textColor="#050506">
                  <Calender />
                  <span>01/01/24 - 25/01/24</span>
                  <CaretDown />
                </ButtonIcon>
                <MonthPicker
                  onSubmit={(data) => downloadStatement(data)}
                  submitText="Download PDF"
                  text={
                    <>
                      <Download />
                      <span>Statement</span>
                      <CaretDown />
                    </>
                  }
                />
              </div>
            </div>
          </div>

          <div className={style.stats_container}>
            <div className={style.stat_item}>
              <div className={style.counter}>
                <span>$ 12.1K</span>
                <TrendUp />
              </div>
              <div className={style.stat_desc}>
                <span>Monthly Sales</span>
              </div>
            </div>

            <div className={style.stat_item}>
              <div className={style.counter}>
                <span>$ 12.1K</span>
                <TrendUp />
              </div>
              <div className={style.stat_desc}>
                <span>Monthly Sales</span>
              </div>
            </div>

            <div className={style.stat_item}>
              <div className={style.counter}>
                <span>$ 12.1K</span>
                <TrendUp />
              </div>
              <div className={style.stat_desc}>
                <span>Monthly Sales</span>
              </div>
            </div>

            <div className={style.stat_item}>
              <div className={style.counter}>
                <span>$ 12.1K</span>
                <TrendUp />
              </div>
              <div className={style.stat_desc}>
                <span>Monthly Sales</span>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div>
            <Tabs tabs={tabs} onSelect={handleTabSelect} active_index={0} />
          </div>
        </>
      )}

      {loading && (
        <div className={style.loader_section}>
          <Spinner />
        </div>
      )}
    </div>
  );
}

export default Details;
